import { useCallback } from "react";
import useDateStore from "./use-date-range-store";
import { Moment } from "moment";

const useDate = () => {
  const { selectedDate, setSelectedDate } = useDateStore();

  const changeDate = useCallback(
    (date: Moment) => {
      setSelectedDate(date);
    },
    [setSelectedDate]
  );

  return {
    selectedDate,
    changeDate,
    formattedDate: selectedDate.format("MMM DD, YYYY"),
  };
};

export default useDate;
